import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/lib/api';
import { useToast } from './useToast';

export function useWishlist() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  const { data: wishlist = [], isLoading } = useQuery({
    queryKey: ['wishlist'],
    queryFn: async () => {
      const res = await api.get('/wishlist');
      return res.data;
    },
    retry: false
  });

  const toggleMutation = useMutation({
    mutationFn: async (produtoId: string) => {
      const res = await api.post('/wishlist/toggle', { produtoId });
      return res.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['wishlist'] });
      toast({
        title: data.status === 'ADICIONADO' ? 'Adicionado à Lista de Desejos' : 'Removido da Lista de Desejos',
        description: data.status === 'ADICIONADO' ? 'Nós te avisaremos se houver promoções!' : 'Item removido.',
      });
    },
    onError: () => {
      toast({
        title: 'Erro',
        description: 'Você precisa estar logado para salvar favoritos.',
        variant: 'destructive'
      });
    }
  });

  const isFavorited = (produtoId: string) => {
    return wishlist.some((item: any) => item.produtoId === produtoId);
  };

  return {
    wishlist,
    isLoading,
    toggleWishlist: toggleMutation.mutate,
    isFavorited
  };
}
